// extracted by mini-css-extract-plugin
export var bounce = "_gl-1";
export var generatingText = "_gl-6";
export var lightning = "_gl-4";
export var popup = "_gl-5";
export var progressBar = "_gl-7";
export var progressFill = "_gl-8";
export var progressShimmer = "_gl-9";
export var progressText = "_gl-a";
export var shimmer = "_gl-3";
export var uploadIcon = "_gl-0";
export var uploadingText = "_gl-2";